import axios from 'axios';
import { ApiEndPoints } from '../api-end-points';

const AxiosInstance = axios.create({
  baseURL: ApiEndPoints.base_url,
});

export default AxiosInstance;
